import type { IElementConfig } from './types';

// ----------------------------------------------------------------------------

function clear(config: IElementConfig): Partial<IElementConfig> {
    const cleanConfig = { ...config };

    delete cleanConfig.container;
    delete cleanConfig.class;
    delete cleanConfig.attr;
    delete cleanConfig.style;
    delete cleanConfig.dataset;
    delete cleanConfig.html;
    delete cleanConfig.event;

    return cleanConfig;
}

// ----------------------------------------------------------------------------

export default clear;
